/**
 * TextNoteEditor - Default text area editor for most nodes
 *
 * Simple free-form text input for company-specific notes on a node.
 */

import { useState, useCallback } from 'react'

export interface TextNoteEditorProps {
  value: string
  onSave: (value: string) => void
  onCancel: () => void
  saving: boolean
}

export function TextNoteEditor({
  value,
  onSave,
  onCancel,
  saving
}: TextNoteEditorProps) {
  const [text, setText] = useState(value)

  const handleSave = useCallback(() => {
    onSave(text)
  }, [text, onSave])

  const handleClear = useCallback(() => {
    setText('')
  }, [])

  return (
    <div className="editor-form">
      <div className="editor-field">
        <label htmlFor="node-note">Company Note</label>
        <textarea
          id="node-note"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter company-specific information for this node..."
          rows={8}
        />
      </div>

      <div className="editor-buttons">
        {text && (
          <button
            type="button"
            className="editor-btn editor-btn-secondary"
            onClick={handleClear}
            disabled={saving}
          >
            Clear
          </button>
        )}
        <button
          type="button"
          className="editor-btn editor-btn-secondary"
          onClick={onCancel}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          type="button"
          className="editor-btn editor-btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  )
}

export default TextNoteEditor
